import { render, staticRenderFns } from "./AddressAdd.vue?vue&type=template&id=4b7f6e38&scoped=true&"
import script from "./AddressAdd.vue?vue&type=script&lang=js&"
export * from "./AddressAdd.vue?vue&type=script&lang=js&"
import style0 from "./AddressAdd.vue?vue&type=style&index=0&id=4b7f6e38&prod&lang=scss&"
import style1 from "./AddressAdd.vue?vue&type=style&index=1&id=4b7f6e38&prod&lang=scss&"
import style2 from "./AddressAdd.vue?vue&type=style&index=2&id=4b7f6e38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f6e38",
  null
  
)

export default component.exports